<section class="loginpg-seccont">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 text-end"><img src="/assets/images/loign-img.png" class="img-fluid" /></div>
      <div class="col-md-6 align-self-center">
        <div class="text-center col-md-12 col-12"><img src="/assets/images/logo.png" class="img-fluid" /></div>
        <ng-container *ngIf="isPasswordEnabled()">
          <form [formGroup]="passwordBasedLoginForm">
            <div class="my-3 col-md-12 col-12 align-self-center">
              <label for="email" class="form-label">Username</label>
              <input type="name" class="form-control" id="email" placeholder="" formControlName="email" />
            </div>
            <div class="my-3 col-md-12 col-12 align-self-center">
              <label for="password" class="form-label">Password</label>
              <app-password-input (passwordChange)="handlePasswordChange($event)"></app-password-input>
            </div>
            <div class="text-center col-md-12 my-3 col-12">
              <button type="button" class="btnlogin" (click)="login()">LOGIN <i class="fa fa-arrow-right"></i></button>
            </div>
          </form>

          <div class="text-center my-3 col-md-12 col-12 lgnpglstlink forgot-password">
            <a (click)="openTargetComponent()">Forgot Password? Click here to reset</a>
          </div>
        </ng-container>
        <ng-container *ngIf="isOTPEnabled()">
          <form [formGroup]="otpBasedLoginForm" class="otp-login-container">
            <div class="my-3 col-md-12 col-12 align-self-center">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" formControlName="email" [readonly]="showOtp" />
            </div>

            <div class="otp-section d-flex justify-content-evenly form-group" *ngIf="showOtp">
              <label class="form-label text-center">Enter OTP</label>
              <div class="otp-row">
                <ng-otp-input [config]="otpConfig" (onInputChange)="onOtpChange($event)"> </ng-otp-input>
              </div>
            </div>

            <div class="otp-actions">
              <button
                *ngIf="!showOtp"
                type="button"
                class="btnlogin"
                (click)="generateOtp()"
                [disabled]="otpBasedLoginForm.get('email')?.invalid">
                GENERATE OTP <i class="fa fa-arrow-right"></i>
              </button>

              <button
                *ngIf="showOtp"
                type="button"
                class="btnlogin"
                (click)="loginWithOtp()"
                [disabled]="otpBasedLoginForm.get('otp')?.value?.length !== otpLength">
                LOGIN <i class="fa fa-arrow-right"></i>
              </button>

              <button
                *ngIf="showOtp"
                type="button"
                class="btnlogin"
                (click)="resendOtp()"
                [disabled]="!canResendOtp || resendLimitReached">
                RESEND OTP
              </button>
            </div>

            <div class="resend-hint" *ngIf="showOtp && !canResendOtp && !resendLimitReached">
              Resend OTP in {{ resendCountdown }} seconds
            </div>

            <div class="resend-hint text-danger" *ngIf="resendLimitReached">
              You have reached the maximum OTP requests. Please try again later.
            </div>
          </form>
        </ng-container>
        <ng-container *ngIf="isSSOEnabled()">
          <div class="text-center col-md-12 my-3 col-12">
            <button type="button" class="btnlogin sso-login-button mt-4" (click)="loginWithSSO()">
              LOGIN USING SSO <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<div #targetContainer></div>
